import React, {useEffect, useState} from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import FormDateTimeElement from './FormDateTimeElement';
import moment from 'moment';
import DateBind from 'components/complex/offer/components/DateBind';
import periodValues from 'components/complex/offer/components/constants/period.values'
import Loading from 'components/Loading';
import {connect} from 'react-redux'
import getObjectValue from 'libs/getObjectValue'
import * as Yup from 'yup';
import ScheduleService from 'services/ScheduleService';
import {withRouter} from "react-router";
import SaveFormikValues from 'components/SaveFormikValues';
import {DemandValidation} from 'constants/DemandValidation';
import VS from "constants/ValidationShema";
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import {setFormDraftLoaded} from "redux/actions";
import Confirm from "components/popup/confirm/Confirm";
import AutoSaveFormValues from "components/AutoSaveFormValues";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import saveFormDraft from "libs/saveFormDraft";
import {isEuropeProcedure, isNationalProcedure, ProcedureType} from 'constants/ProcedureType'
import FormDateElement from "./FormDateElement";
import {isMoment} from "moment/moment";
import {Alert} from "@material-ui/lab";
import {makeStyles} from "@material-ui/core/styles";
import BooleanItems from "constants/BooleanItems";
import Select from "components/Select";

const useStyle = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    select: {
        marginLeft: theme.spacing(2),
        width: '35%',
        "& .MuiInputLabel-root": {
            fontWeight: 700
        }
    }
}))

function Deadlines(
    {
        scheduleList,
        stepperState,
        demandValidation,
        match,
        setFormDraftLoaded,
        demandHeader
    }) {
    const classes = useStyle();
    const id = match.params.id;
    const section = demandValidation.find(x => x.section === DemandValidation.SCHEDULE);
    const editable = section ? section.editable : true;
    const FORM_ID = 'mp_1_schedule';
    const IS_UNLIMITED_TENDER = demandHeader?.demandRealizationType === 'unlimited_tender';
    const IS_LIMITED_TENDER = demandHeader?.demandRealizationType === 'limited_tender';
    const [draftConfirm, setDraftConfirm] = useState(false);
    const [working, setWorking] = useState(false);
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    const showNoticeToPOEUDate = isEuropeProcedure(demandHeader?.procedureType)
        || demandHeader?.procedureType === ProcedureType.COMPETITION
        || demandHeader?.procedureType === ProcedureType.DYNAMICPURCHASINGSYSTEM;
    const isModification = isDemandModification();
    const showShortenedEndDateMode = showNoticeToPOEUDate && (IS_LIMITED_TENDER || IS_UNLIMITED_TENDER);
    const showQuestionDeadlines = showNoticeToPOEUDate || isNationalProcedure(demandHeader?.procedureType);
    useStepperStateCloseValidator(FORM_ID, undefined,
        autoSaveFormDraftActive ? () => ScheduleService.deleteDraft(id) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(id, ScheduleService.saveDraft, FORM_ID) : undefined);

    useEffect(() => {
        ScheduleService.getList(id).then(() => {
            if (autoSaveFormDraftActive)
                ScheduleService.checkForDraft(id).then(res => setDraftConfirm(res.result))
        });

        return () => ScheduleService.clearSchedule()
    }, [id, autoSaveFormDraftActive])

    const handleSubmit = (values, formikProps) => {
        ScheduleService.save(id, values)
            .then((result) => {
                if (result && !result.success) {
                    const errors = result.errors;
                    let errorObj = {}
                    Object.keys(errors).forEach((errorId) => {
                        const erId = errorId.split('.')[1];
                        errorObj[erId] = errors[errorId];
                    })
                    formikProps.setErrors(errorObj)
                }
            })
    }

    const getField = (id, defaultValue = '') => getObjectValue(id, scheduleList.schedules.length > 0 ? scheduleList.schedules[0] : {}, defaultValue)
    const getDateField = (id) => {
        let value = getField(id);
        return value ? moment(value) : null;
    }

    const validationSchema = Yup.lazy((value) => {
        const schema = {
            offerEndDate: VS.dateTimeMin(new Date(), Tr('v_time_can_not_be_past')),
            offerOpenDate: VS.dateTimeValid()
                .when('offerEndDate', (offerEndDate, schema) => {
                    return schema.test('EndDateLessOpenDate', Tr("EndDateLessOpenDate"), (offerOpenDate) => {
                        if (offerEndDate && offerOpenDate) {
                            return !offerOpenDate.isBefore(offerEndDate);
                        }
                        return false;
                    })
                }),
            noticeToPOEUDate: VS.dateTimeNoReq(),
            shortenedEndDateMode: showNoticeToPOEUDate ? VS.anyRequired() : VS.any()
        }

        let offerOpenDateClone = moment.isMoment(value.offerOpenDate) ? (value.offerOpenDate.isValid() ? value.offerOpenDate.clone().startOf("day") : moment()) : moment();
        offerOpenDateClone = offerOpenDateClone.isBefore(moment().add(1, 'day')) ? moment().add(1, 'day') : offerOpenDateClone;

        if (value.bindWithOfferPeriodOrDate.pickDateInsteadOfPeriod === 'true') {
            schema['bindWithOfferPeriodOrDate'] = Yup.object().shape({
                date: VS.dateMin(offerOpenDateClone, Tr('periodDateLessThanOpenDate'))
            })

        }

        return Yup.object().shape(schema);
    })

    const getPickDateInsteadOfPeriod = () => {
        const date = getField('bindWithOfferPeriodOrDate.date', null);
        if (date === null) {
            const periodLen = getField('bindWithOfferPeriodOrDate.period.length', null);
            if (periodLen === null) return 'empty'
            return 'false'
        }
        return 'true'
    }
    const handleEndDate = (formikProps, value) => {
        formikProps.setFieldValue('offerOpenDate', value);
        formikProps.setFieldTouched('offerOpenDate', true);
        formikProps.validateField('offerOpenDate');

        let noticeToPOEUDate = getObjectValue('noticeToPOEUDate', formikProps.values, null);
        noticeToPOEUDate =  noticeToPOEUDate ? moment(noticeToPOEUDate) : null;
        if (!isDateValid(value) || (noticeToPOEUDate !== null && !isDateValid(noticeToPOEUDate))) {
            return;
        }
        const shortenedEndDateMode = getObjectValue('shortenedEndDateMode', formikProps.values, null);
        ScheduleService.calculateStageDates(id, {stageNumber: getField('stageNumber'), offerEndDate: value, noticeToPOEUDate: noticeToPOEUDate, shortenedEndDateMode: shortenedEndDateMode })
            .then((resp) => {
                if (!isModification) {
                    formikProps.setFieldValue('questionEndDate', resp.questionEndDate ? moment(resp.questionEndDate) : null);
                    formikProps.setFieldTouched('questionEndDate', true);
                    formikProps.setFieldValue('questionAnswerEndDate', resp.questionAnswerEndDate ? moment(resp.questionAnswerEndDate) : null);
                    formikProps.setFieldTouched('questionAnswerEndDate', true);
                }
                if (resp.bindWithTheOfferPeriodOrDate.date) {
                    formikProps.setFieldValue('bindWithOfferPeriodOrDate.pickDateInsteadOfPeriod', 'true');
                    formikProps.setFieldTouched('bindWithOfferPeriodOrDate.pickDateInsteadOfPeriod', true);
                    formikProps.setFieldValue('bindWithOfferPeriodOrDate.date', moment(resp.bindWithTheOfferPeriodOrDate.date));
                    formikProps.setFieldTouched('bindWithOfferPeriodOrDate.date', true);
                }
            }).catch(error => {
                console.log("Couldn't fetch calculated question dates");
        });
    }

    const handleNoticeToPOUEDate = (formikProps, value) => {
        formikProps.validateField('noticeToPOEUDate');
        let offerEndDate = getObjectValue('offerEndDate', formikProps.values, null);
        offerEndDate = offerEndDate ? moment(offerEndDate) : null;
        if (!isDateValid(offerEndDate) || !isDateValid(value)) {
            return;
        }
        const shortenedEndDateMode = getObjectValue('shortenedEndDateMode', formikProps.values, null);
        ScheduleService.calculateStageDates(id, {stageNumber: getField('stageNumber'), offerEndDate: offerEndDate, noticeToPOEUDate: value, shortenedEndDateMode: shortenedEndDateMode })
            .then((resp) => {
                formikProps.setFieldValue('questionEndDate', resp.questionEndDate ? moment(resp.questionEndDate) : null);
                formikProps.setFieldTouched('questionEndDate', true);
                formikProps.setFieldValue('questionAnswerEndDate', resp.questionAnswerEndDate ? moment(resp.questionAnswerEndDate) : null);
                formikProps.setFieldTouched('questionAnswerEndDate', true);
            }).catch(error => {
            console.log("Couldn't fetch calculated question dates");
        });
    }

    const handleShortenedEndDateMode = (formikProps, value) => {
        let offerEndDate = getObjectValue('offerEndDate', formikProps.values, null);
        offerEndDate = offerEndDate ? moment(offerEndDate) : null;
        let noticeToPOEUDate = getObjectValue('noticeToPOEUDate', formikProps.values, null);
        noticeToPOEUDate =  noticeToPOEUDate ? moment(noticeToPOEUDate) : null;
        if (offerEndDate === null || !isDateValid(offerEndDate) || (noticeToPOEUDate !== null && !isDateValid(noticeToPOEUDate))) {
            return;
        }

        ScheduleService.calculateStageDates(id, {stageNumber: getField('stageNumber'), offerEndDate: offerEndDate, noticeToPOEUDate: noticeToPOEUDate, shortenedEndDateMode: value.target.value })
            .then((resp) => {
                formikProps.setFieldValue('questionEndDate', resp.questionEndDate ? moment(resp.questionEndDate) : null);
                formikProps.setFieldTouched('questionEndDate', true);
                formikProps.setFieldValue('questionAnswerEndDate', resp.questionAnswerEndDate ? moment(resp.questionAnswerEndDate) : null);
                formikProps.setFieldTouched('questionAnswerEndDate', true);
            }).catch(error => {
                console.log("Couldn't fetch calculated question dates");
            });
    }

    const isDateValid = (date) => {
        let dateToCompare = date;
        if (!isMoment(date)) {
            dateToCompare = moment(date);
        }
        return dateToCompare.isValid();
    }
    const getInitValues = () => ({
        _editable: editable,
        stageNumber: getField('stageNumber'),
        stageName: getField('stageName'),
        noticeToPOEUDate: getDateField('noticeToPOEUDate'),
        questionEndDate: getDateField('questionEndDate'),
        questionAnswerEndDate: getDateField('questionAnswerEndDate'),

        identity: getField('identity'),
        offerEndDate: moment(getField('offerEndDate', new Date())),
        offerOpenDate: moment(getField('offerOpenDate', new Date())),
        bindWithOfferPeriodOrDate: {
            date: moment(getField('bindWithOfferPeriodOrDate.date', new Date())),
            period: {
                length: getField('bindWithOfferPeriodOrDate.period.length', periodValues[0].value),
                name: getField('bindWithOfferPeriodOrDate.period.name', 'day'),
            },
            pickDateInsteadOfPeriod: getPickDateInsteadOfPeriod(),
        },
        shortenedEndDateMode: getField('shortenedEndDateMode', null)
    })

    const loadScheduleDraft = () => {
        setDraftConfirm(false);
        setWorking(true);
        ScheduleService.loadDraft(id).then(res => setFormDraftLoaded(FORM_ID, res.success));
        setWorking(false);
    }

    if (!scheduleList || working) {
        return <Loading/>
    }

    return (
        <div>
            <Form
                initialValues={getInitValues()}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                id={FORM_ID}
                afterSubmitFunc={() => {
                    if (isModification) {
                        ModificationService.isDemandChanged(id);
                    }
                }}
            >
                {(formikProps) => (
                    <>
                        <SaveFormikValues
                            formikProps={formikProps}
                            id={FORM_ID}
                            save={FORM_ID === stepperState}
                        />
                        {autoSaveFormDraftActive &&
                            <AutoSaveFormValues
                                formikProps={formikProps}
                                id={id}
                                formId={FORM_ID}
                                saveFunc={(formValues) => {
                                    const offerEndDate = getObjectValue('offerEndDate', formikProps.values, null);
                                    const offerOpenDate = getObjectValue('offerOpenDate', formikProps.values, null);
                                    const noticeToPOEUDate = getObjectValue('noticeToPOEUDate', formikProps.values, null);
                                    const bindWithOfferDate = getObjectValue('bindWithOfferPeriodOrDate.date', formikProps.values, null);
                                    const valid = isDateValid(offerEndDate) && isDateValid(offerOpenDate) && (noticeToPOEUDate === null || isDateValid(noticeToPOEUDate)) && (bindWithOfferDate === null || isDateValid(bindWithOfferDate));
                                    if (valid) {
                                        ScheduleService.saveDraft(id, formValues);
                                    }
                                }}
                            />
                        }
                        <GridBlock
                            direction='column'
                        >
                            <Typography variant='h6'>
                                {Tr('offers')}
                            </Typography>
                            {!!section.messages &&
                                section.messages.map((x, i) => <Alert key={i} severity="warning" classes={classes}>{x}</Alert>)
                            }
                            <FormDateTimeElement
                                title={Tr('deadline_for_offers')}
                                formikProps={formikProps}
                                id={'offerEndDate'}
                                onChange={(value) => handleEndDate(formikProps, value)}
                                required
                            />
                            <FormDateTimeElement
                                title={Tr('date_opening_offers')}
                                formikProps={formikProps}
                                id={'offerOpenDate'}
                                required
                            />
                            {showNoticeToPOEUDate &&
                                <FormDateElement
                                    title={Tr('deadline_for_notice_to_POEU')}
                                    formikProps={formikProps}
                                    disabled={isModification}
                                    id={'noticeToPOEUDate'}
                                    required={false}
                                    onChange={(value) => handleNoticeToPOUEDate(formikProps, value)}
                                    minDate={new Date('2020-01-01')}
                                />
                            }
                            {showShortenedEndDateMode &&
                                <Select
                                    className={classes.select}
                                    label={IS_LIMITED_TENDER ? Tr('shortenedEndDateModeLimitedTender') : Tr('shortenedEndDateMode')}
                                    formikProps={formikProps}
                                    id={'shortenedEndDateMode'}
                                    required
                                    disabled={!editable}
                                    items={BooleanItems}
                                    onChange={(value) => handleShortenedEndDateMode(formikProps, value)}
                                />
                            }
                            {showQuestionDeadlines &&
                                <FormDateElement
                                    title={Tr('deadline_for_submitting_questions')}
                                    formikProps={formikProps}
                                    id={'questionEndDate'}
                                    required={false}
                                    disabled={false}
                                    tooltip={Tr('until_the_end_of_the_day')}
                                    hideTooltip={false}
                                    minDate={new Date('2020-01-01')}
                                />
                            }
                            {showQuestionDeadlines &&
                                <FormDateElement
                                    title={Tr('deadline_for_responding_to_asked_questions')}
                                    formikProps={formikProps}
                                    id={'questionAnswerEndDate'}
                                    required={false}
                                    disabled={false}
                                    tooltip={Tr('until_the_end_of_the_day')}
                                    hideTooltip={false}
                                    minDate={new Date('2020-01-01')}
                                />
                            }
                            <DateBind
                                title={Tr('date_binding_offer')}
                                formikProps={formikProps}
                                initialPickDateInsteadOfPeriod={getPickDateInsteadOfPeriod()}
                            />
                        </GridBlock>
                    </>
                )}
            </Form>
            <Confirm
                open={draftConfirm}
                onConfirm={loadScheduleDraft}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </div>
    )
}

Deadlines.propTypes = {
    classes: PropTypes.any,
}

Deadlines.defaultProps = {}

export default connect((state) => ({
    scheduleList: state.resources.schedule,
    stepperState: state.stepper.state,
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader
}), {setFormDraftLoaded})(withRouter(Deadlines));

